import { CalculationSettingsModel, RNAVModel } from './configuration';
import { CurvePointDTO } from './curvePointDTO';

export class TerrainAltitudeCutDTO {

  calculationName: string;
  projectId: number;

  altitudeFT: number;
  altitudeM: number;

  coordinates: CurvePointDTO[] = [];

  calculationSettings: CalculationSettingsModel;
  rnav: RNAVModel;
}
